const getResultCount = (count, translations) => {
  let message = `${count} ${translations['search.multipleResultsFound']}`
  if (count === 0) message = translations['search.noResults']
  if (count === 1) message = translations['search.singleResultFound']

  return message
}

export default getResultCount
